import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/proceso/getPagosByProceso.php';

export default function getPagosByProceso({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}